import isIOS from 'common/utils/isIOS';

const DEFAULT_EVENT = {
  target: null
};

export default class FloatingActionButtonsBehaviour {
  constructor($timeout, $window) {
    'ngInject';
    this.timeout = $timeout;
    this.window = $window;
    this.isFocused = false;
  }

  run() {

    if (!this.window.isMobileApp) {
      return;
    }

    this.timeout(() => {
      this.setInputsBehaviour();
      this.setSelectsBehaviour();

    }, 200);

  }

  getInputs() {
    return $('input[type="text"], input[type="number"], input[type="tel"], input[type="date"]');
  }

  getSelects() {
    return $('select-app span.ui-select-toggle');
  }

  setInputsBehaviour() {
    this.getInputs().click(() => {
      this.timeout(() => {
        $('body').click(() => this.outsideClick(false));
        this.onFocus(DEFAULT_EVENT, false);
      }, 100);
    });
  }

  setSelectsBehaviour() {
    this.getSelects().click(() => {

      this.timeout(() => {

        const options = $('select-app .select-option');
        const optionsAreOpen = options.length > 0;

        if (optionsAreOpen) {
          $('body').click(() => this.outsideClick(true));
          options.click(() => this.outsideClick(true));

          this.onFocus(DEFAULT_EVENT, true);

        }
      }, 100);
    });
  }

  outsideClick(isSelect) {
    this.onBlur(DEFAULT_EVENT, isSelect);
    $('body').unbind('click');
  }

  onFocus(event, isSelect = false) {
    const $target = $(event.target);
    this.isFocused = true;
    $('body').css('cursor', 'pointer');
    $('.container.hpd').addClass('with-floating-action-buttons-hidden');

    $('floating-action-buttons').hide(0, () => {
      if ($target.closest('.modal-dialog').length > 0) {
        $target.closest('.modal-dialog').addClass('on-focus');
      }
    });

    if (isIOS() && !isSelect) {
      $('main-menu-mobile').addClass('focus-fixed');
    }
  }

  onBlur(event, isSelect = false) {
    const $target = $(event.target);
    this.isFocused = false;
    $('body').css('cursor', 'auto');
    $('.container.hpd').removeClass('with-floating-action-buttons-hidden');

    if(isSelect){
      this.timeout(() => {
        document.activeElement.blur();
      }, 200);
    }

    this.timeout(() => {
      $('floating-action-buttons').fadeIn(250, () => {
        this.timeout(() => {
          if ($target.closest('.modal-dialog').length > 0) {
            $target.closest('.modal-dialog').removeClass('on-focus');
          }
        }, 800);
      });
    }, 1000);

    if (isIOS() && !isSelect) {
      $('main-menu-mobile').removeClass('focus-fixed');
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/components/floatingActionButtons/floatingActionButtons.service.js